// extracted by mini-css-extract-plugin
module.exports = {"loadingDiv":"styles_loadingDiv__1I5Gx","secondaryImg":"styles_secondaryImg__2Py_l"};